<template>
  <section
    :data-active="active"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
    @drop.prevent="onDrop"
    class="logo-dropfile"
  >
    <div
      class="logo-dropfile__inner"
      :class="{
        'logo-dropfile__inner--active': active,
        'logo-dropfile__inner--error': hasError,
      }"
    >
      <div class="logo-dropfile__inner-right">
        <p v-if="errorMessage" class="logo-dropfile__error-message">
          {{ errorMessage }}
        </p>
        <h4 class="logo-dropfile__top-text">
          <BaseInputFile
            :accept-types="['image/png', '.png']"
            :max-file-size="2 * 1024"
            @file-changed="handleFileUpload"
          >
            <span style="font-weight: 900; font-size: 25px">
              {{ errorMessage ? 'Choose a different file' : 'Choose a file' }}
            </span>
          </BaseInputFile>
          or drag and drop it here.
        </h4>
        <h5 v-if="galleryCount > 0" class="logo-dropfile__bottom-text">
          OR
          <button
            type="button"
            class="logo-dropfile__button-text"
            @click="$emit('select-from-gallery')"
          >
            select from previous uploads
          </button>
          .
        </h5>
      </div>
      <div class="logo-dropfile__inner-left">
        <img
          v-if="selectedFile && !errorMessage"
          :src="getImageFromSelectedFile()"
          alt="Selected File"
          class="logo-dropfile__selected-image"
        />
        <img
          v-else
          src="/images/icons/image-icon-png.png"
          alt="PNG Image Icon"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import BaseInputFile from '~/components/base/BaseInputFile.vue';

  export default {
    name: 'DatasetDropfile',
    components: { BaseInputFile },
    props: {
      selectedFile: {
        type: File,
        required: false,
        default: null,
      },
      hasError: Boolean,
      galleryCount: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data: () => ({
      active: false,
      errorMessage: null,
    }),
    mounted() {
      if (this.selectedFile) {
        this.validateSelectedFile();
      }
    },
    methods: {
      setActive() {
        this.active = true;
      },
      setInactive() {
        this.active = false;
      },
      onDrop(event) {
        this.errorMessage = null;
        if (!event?.dataTransfer?.files) return;
        this.setInactive();
        this.handleFileUpload(event);
      },

      handleFileUpload(event) {
        let file = null;
        if (event?.target?.files && event.target.files[0]) {
          file = event.target.files[0];
        } else if (event?.dataTransfer?.files && event.dataTransfer.files[0]) {
          file = event.dataTransfer.files[0];
        }

        this.$emit('file-uploaded', file);
      },
      getImageFromSelectedFile() {
        return URL.createObjectURL(this.selectedFile);
      },
      validateSelectedFile() {
        if (this.selectedFile.type !== 'image/png') {
          this.errorMessage = 'Incorrect file format chosen.';
          return;
        }
        if (this.selectedFile.size > 2000000) {
          this.errorMessage = 'File size is too large.';
          return;
        }
      },
    },
    watch: {
      selectedFile(newValue) {
        if (newValue.type !== 'image/png') {
          this.errorMessage = 'Incorrect file format chosen.';
          return;
        }
        if (newValue.size > 2000000) {
          this.errorMessage = 'File size is too large.';
          return;
        }
        this.errorMessage = null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo-dropfile {
    position: relative;
    padding: 15px;
    background-color: #d2d2d3;
    margin-bottom: 2rem;
    &__inner {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px dashed var(--itr-blue-light);
      padding: 47px 60px;
      z-index: 1;

      height: 100%;
      min-height: 265px;

      &--error {
        border: 2px dashed #eb5757;
      }

      &--active {
        z-index: 0;

        &::after {
          transition: background-color 300ms ease-in-out;

          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 0;

          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;

          transition: background-color 300ms ease-in-out;
        }
      }

      &::after {
        display: none;
        background-color: rgba(0, 0, 0, 0);
      }
    }
    &__inner-left {
      padding: 0 10px;
      max-width: 33%;
    }
    &__selected-image {
      border: 3px solid var(--itr-blue);
      border-radius: 8px;
    }
    &__inner-right {
      display: flex;
      flex-direction: column;
      flex: 1 auto;
      text-align: center;
    }
    &__error-message {
      font-size: 25px;
      color: #eb5757;
      margin-bottom: 1rem;
    }
    &__top-text {
      flex: 1 auto;
      color: var(--itr-color-font);
      font-size: 25px;
      font-weight: 500;
    }
    &__bottom-text {
      margin-top: 1.5rem;
      font-size: 16px;
      color: var(--itr-color-font);
    }
    &__button-text {
      padding: 0;
      text-decoration: underline;
      font-weight: 900;
      background-color: transparent;
      color: inherit;
      cursor: pointer;
    }
  }
</style>
